import PropTypes from 'prop-types';
import Link from '@activebrands/core-web/components/Link';
import { styled } from '@activebrands/core-web/libs/styletron';
import ThemeButton from 'components/buttons/ThemeButton';
import Heading from './text/Heading';

const Wrapper = styled('div', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 auto',
});

const NotFound = ({ $style = {}, heading, links }, index) => (
    <Wrapper $style={$style}>
        <Heading $style={{ marginBottom: ['24px', null, null, '32px'] }} as="h2" fontKeys="Secondary/16_100_-02">
            {heading}
        </Heading>
        {links?.map(({ label, url, rel }, i) => (
            <ThemeButton
                isVolatile
                $style={{ display: 'block', marginBottom: links.length - 1 !== i ? '16px' : '' }}
                as={Link}
                key={index}
                rel={rel}
                theme="default"
                to={url}
            >
                {label}
            </ThemeButton>
        ))}
    </Wrapper>
);

NotFound.propTypes = {
    $style: PropTypes.object,
    heading: PropTypes.string.isRequired,
    links: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.string,
            url: PropTypes.string.isRequired,
            rel: PropTypes.string,
        })
    ),
};

export default NotFound;
